import { scope } from "../../../exports/debug.js";
import type { ProxyTarget, TargetStore } from "./store.types.js";

/**
 *
 */
export const nexusScope = scope("nexus");

/**
 *
 *
 *
 */
export function getStoreType(store: TargetStore): string {
  const candidate = (
    [
      [store.isNs, "Namespace"],
      [store.isFunc, "Function"],
      [store.isSig, "Signal"],
    ] as const
  ).find(([v]) => !!v)?.[1];

  if (!candidate) return "NexusWrapper";
  if (store.isReady) return candidate;
  return `Pending ${candidate}`;
}

export const stores = new WeakMap<ProxyTarget, TargetStore>();

/**
 *
 *
 *
 */
export const getStore = (target: ProxyTarget): TargetStore => stores.get(target) as never;
